import { Action, createAction, handleActions } from "redux-actions";
import { FechaFiltro, FiltroValue, TakeValue } from "../../types";

interface FiltrosPolizasState {
  page: number;
  take: TakeValue;
  searchCriteria: string;
  estado: FiltroValue;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
  negocio: FiltroValue;
  soloParaRenovar: boolean;
  compania: FiltroValue;
}

const setInitialStatePolizas = createAction("SET_INITIAL_STATE_FILTRO_POLIZAS");

const setPage = createAction("SET_LISTADO_POLIZAS_PAGE", (page: number) => ({
  page,
}));

const setTake = createAction(
  "SET_LISTADO_POLIZAS_ROWS_PER_PAGE",
  (take: TakeValue) => ({
    take,
  })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_POLIZAS",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectFechaDesde = createAction(
  "SELECT_FECHA_DESDE_POLIZAS",
  (fechaDesde: FechaFiltro) => ({ fechaDesde })
);

const selectFechaHasta = createAction(
  "SELECT_FECHA_HASTA_POLIZAS",
  (fechaHasta: FechaFiltro) => ({ fechaHasta })
);

const selectEstado = createAction(
  "SELECT_ESTADO_FILTRO_POLIZAS",
  (estado: FiltroValue) => ({
    estado,
  })
);

const selectNegocio = createAction(
  "SELECT_NEGOCIO_FILTRO_POLIZAS",
  (negocio: FiltroValue) => ({
    negocio,
  })
);

const selectCompania = createAction(
  "SELECT_COMPANIA_FILTRO_POLIZAS",
  (compania: FiltroValue) => ({
    compania,
  })
);

const setBuscarSoloParaRenovar = createAction(
  "SELECT_BUSCAR_SOLO_RENOVAR_POLIZAS",
  (soloParaRenovar: boolean) => ({ soloParaRenovar })
);

const filtrosPolizasInitialState: FiltrosPolizasState = {
  page: 0,
  take: 10,
  searchCriteria: "",
  estado: "",
  fechaDesde: null,
  fechaHasta: null,
  negocio: "",
  soloParaRenovar: false,
  compania: "",
};

const filtrosPolizasReducer = handleActions<FiltrosPolizasState, any>(
  {
    [setInitialStatePolizas.toString()]: (): FiltrosPolizasState => {
      return {
        ...filtrosPolizasInitialState,
      };
    },
    [setPage.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ page: number }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ take: TakeValue }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        page: 0,
        take: action.payload.take,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ estado: FiltroValue }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        estado: action.payload.estado,
      };
    },
    [selectFechaDesde.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ fechaDesde: FechaFiltro }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        fechaDesde: action.payload.fechaDesde,
      };
    },
    [selectFechaHasta.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ fechaHasta: FechaFiltro }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        fechaHasta: action.payload.fechaHasta,
      };
    },
    [selectCompania.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ compania: FiltroValue }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        compania: action.payload.compania,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectNegocio.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ negocio: FiltroValue }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        negocio: action.payload.negocio,
      };
    },
    [setBuscarSoloParaRenovar.toString()]: (
      state: FiltrosPolizasState,
      action: Action<{ soloParaRenovar: boolean }>
    ): FiltrosPolizasState => {
      return {
        ...state,
        soloParaRenovar: action.payload.soloParaRenovar,
      };
    },
  },
  filtrosPolizasInitialState
);

export { filtrosPolizasReducer };
export {
  setInitialStatePolizas,
  selectSearchCriteria,
  selectEstado,
  selectNegocio,
  setPage,
  setTake,
  setBuscarSoloParaRenovar,
  selectCompania,
  selectFechaDesde,
  selectFechaHasta,
};
